/**
 * 真人建档「上传体检」失败原因的展示口径(修复波 0926 第十一批 B2 #22)。
 *
 * ★K2 实测:体检失败态把接口 `reason` 原样印出来,而 ai 侧 fail-closed 时 reason 是一段
 *   「HTTP 400 …{json}」原文 —— 内部地址、英文异常直接给到用户。
 * ★只放**人话**:短、含中文、不带 URL / 大括号 / 异常栈 / HTTP 状态字样;其余一律兜底句
 *   「没检测到人脸,请换一张正脸照」。原文不进屏幕(与 noRawErrorMessage 守卫同一条纪律,
 *   这里不读 `.message`,读的是业务字段 reason)。
 */
export const FACE_PRECHECK_FALLBACK = "没检测到人脸,请换一张正脸照";

const RAW_MARKERS =
  /https?:\/\/|\bHTTP\b|[{}[\]]|Traceback|Exception|\bError\b|status[_ ]?code|\\n|<\/?\w+>/i;
const MAX_HUMAN_LEN = 60;

export function facePrecheckReasonText(reason: string | null | undefined): string {
  const r = (reason ?? "").trim();
  if (!r) return FACE_PRECHECK_FALLBACK;
  if (RAW_MARKERS.test(r)) return FACE_PRECHECK_FALLBACK;
  if (!/[一-鿿]/.test(r)) return FACE_PRECHECK_FALLBACK; // 全英文 / 码 = 不是给人看的
  if (r.length > MAX_HUMAN_LEN) return FACE_PRECHECK_FALLBACK;
  return r;
}
